<template>
    <tr class="font-costea text-t12 border-b pb-3 h-14">
      <td>
        <button @click="removeManoObra" class="mx-2 cursor-pointer bg-costeaContainer text-costeaGray hover:bg-costeaSalmonDisabled hover:text-costeaSalmon rounded-full w-5 h-5 flex justify-center items-center"><i class="ri-close-fill"></i></button>
      </td>
      <td>
        <select
          v-model="areaSelected"
          name="tipoIdentificacion"
          id="tipoIdentificacion"
          class="
            bg-white
            border-gray-200
            border-solid
            border-2
            w-11/12
            h-10
            justify-start
            items-center
            outline-none
            py-2
            px-3
            rounded-md
            text-t14">
          <option value="" disabled>Seleccione un área</option>
          <option v-for="area in areas" :key="area.index" :value="area.id">{{area.name}}</option>
        </select>
      </td>
      <td>
        <input
          type="text"
          name="area"
          id="area"
          class="
            bg-costeaContainer
            w-8/12
            h-10
            flex
            justify-start
            items-center
            outline-none
            py-2
            px-3
            rounded-md
            text-t14
          "
          disabled
          :value="areaSelect.horas_hombre"
        />
      </td>
      <td>
        <input
          type="text"
          v-model="tiempoStandar"
          name="tiempo"
          id="tiempo"
          class="
            bg-white
            border-gray-200
            border-solid
            border-2
            w-6/12
            h-10
            flex
            justify-start
            items-center
            outline-none
            py-2
            px-3
            rounded-md
            text-t14 text-center"
        />
      </td>
      <td>
        <span class="text-t14 cursor-pointer text-costeaGray">$ {{calcManoObra === 'NaN' ? 0 : calcManoObra}}</span>
      </td>
      <td>
        <button @click="addManoObra" class="ring-4 ring-costeaPrimaryDisabled ring-opacity-30 mx-2 cursor-pointer bg-costeaPrimaryDisabled text-costeaPrimary hover:bg-costeaPrimary hover:text-white rounded-full w-5 h-5 flex justify-center items-center"><i class="ri-check-fill"></i></button>
      </td>
    </tr>
</template>

<script>
import {mapState, mapMutations} from 'vuex'
import axios from 'axios'
export default {
    data(){
        return{
            areaSelected:0,
            costoManoObra: 0,
            tiempoStandar: '',
            areas: [],
            products: []
        }
    },
    computed:{
        ...mapState(['costea']),
        ...mapState(['companyAreas']),
        ...mapMutations(['calcTotalManoObra']),
        calcManoObra(){
          let total = 0
          let costoHora = Number(this.areaSelect.horas_hombre)
          let tiempoStandar = Number(this.tiempoStandar)
          if(!tiempoStandar || tiempoStandar <= 0){
            total = costoHora * 1;
          }else{
            total = costoHora * tiempoStandar;
          }
          total = total.toFixed(2)
          return total
        },
        calcSubTotalManoObra(subtotal){
          let total = 0
           total += subtotal
          return total
        },
        areaSelect(){          
          let horas_hombre
          let name
          for(let i = 0; i < this.areas.length ; i++){
            if(this.areas[i].id === this.areaSelected){
              let costoArea = Number(this.areas[i].costo_total_del_area)
              let horasHombre = Number(this.areas[i].horas_hombre_por_mes)
              let numHombres = Number(this.areas[i].numero_de_personas)
              horas_hombre = this.calcCostoHoraHombre(costoArea, horasHombre, numHombres)
              name = this.areas[i].name
            }
          }
          let areaFilter = {
            horas_hombre: horas_hombre,
            name: name,
          }
          return areaFilter
        },
    },
    methods:{
      calcCostoHoraHombre(costoArea, horasHombre, numHombres){
        let costoTotal = costoArea / (horasHombre * numHombres)
        costoTotal = costoTotal.toFixed(2)
        return costoTotal
      },
      removeManoObra(){
        this.$emit('removeManoObraArea', -1)
      },
      getAreas(){
          axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}areasempresa`)
          .then(response =>{
            this.areas = response.data;
          })
          .catch(error => console.log(error)) 
      },
      getProductById(){
        axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto-view/${this.$route.params.id}`)
        .then(
          res =>{
            this.products = res.data.data
          })
        .catch(error => console.log(error))
      },
      addManoObra(){
        axios.post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}mod-add`,
        {
          id_area: this.areaSelected,
          nombre_mod: this.areaSelect.name,
          costo_hora_hombre: this.areaSelect.horas_hombre,
          tiempo_standar: this.tiempoStandar ? this.tiempoStandar : 0,
          costo_por_area: this.calcManoObra
        }).then(response => {
          if(response.status === 200){
            let mods = [response.data.success.MOD.id]
            let prod = this.products.modirectas
            for(var i=0; i< prod.length; i++){
                mods.push(prod[i].mano_obra_directa_id)
            }
            axios.post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}producto/mod-add/${this.$route.params.id}`, {mano_obra_directa_id: mods})
            .then(
                this.toggleModal(),
                this.removeManoObra()
            ).catch(error => console.log(error))
          }
        }
        ).catch(error => console.log(error))

      },
      toggleModal(){
        this.$emit('reloadData', true)
      },   
    },
    created(){
      this.getAreas(),
      this.getProductById()
    }
};
</script>

<style>
</style>